export class KeyChain {
    Id?: number;
    LegacyId?: string;
    OracleId?: string;
    SalesforceId?: string;
}